import { createElement } from 'react'
import {
    Infinity,
    Archive,
    ArchiveRestore,
    ArrowDown,
    ArrowDownWideNarrow,
    ArrowLeft,
    ArrowRight,
    ArrowUp,
    ArrowUpDown,
    ArrowUpNarrowWide,
    ArrowUpToLine,
    BadgeCheck,
    Ban,
    Bold,
    Bolt,
    Boxes,
    Calendar,
    CalendarCheck,
    CalendarClock,
    CalendarDays,
    Check,
    CheckCircle,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Circle,
    CircleAlert,
    CircleArrowUp,
    CircleChevronDown,
    CircleChevronUp,
    CircleDot,
    Code,
    Copy,
    EllipsisVertical,
    ExternalLink,
    Eye,
    EyeOff,
    Flame,
    FlaskConical,
    Folder,
    Globe,
    GripVertical,
    Headphones,
    House,
    Inbox,
    Info,
    Italic,
    Link,
    Link2Off,
    List,
    ListFilter,
    ListOrdered,
    ListTree,
    LucideProps,
    Maximize2,
    Megaphone,
    Menu,
    MessageSquare,
    Minimize2,
    Minus,
    PanelLeft,
    PanelRight,
    Pause,
    Pencil,
    Play,
    Plus,
    Quote,
    RefreshCw,
    Repeat2,
    Save,
    Search,
    Settings,
    Share,
    Square,
    SquareCheck,
    SquareCode,
    SquareMinus,
    SquarePen,
    SquarePlus,
    Star,
    StickyNote,
    Strikethrough,
    Tag,
    Timer,
    Trash,
    TrendingUp,
    TriangleAlert,
    Underline,
    User,
    Users,
    Video,
    X,
} from 'lucide-react'

const FilledSquare = ({ color = 'currentColor', size = 24, ...props }: LucideProps) =>
    createElement(
        'svg',
        {
            ...props,
            color,
            fill: 'none',
            height: size,
            viewBox: '0 0 24 24',
            width: size,
            xmlns: 'http://www.w3.org/2000/svg',
        },
        createElement('rect', { fill: 'currentColor', height: 18, rx: 2, width: 18, x: 3, y: 3 })
    )

export const logos = Object.freeze({
    generaltask_mark: '/images/gt-mark.svg',
    generaltask_single_color: 'images/gt-logo-single-color.svg',
    generaltask: '/images/generaltask.svg',
    generaltask_yellow_circle: '/images/gt-logo-yellow-circle.png',
    gmail: '/images/google.svg',
    gcal: '/images/gcal.png',
    google_meet: '/images/google-meet.svg',
})

export const icons = Object.freeze({
    arrow_ascend: ArrowUpNarrowWide,
    arrow_descend: ArrowDownWideNarrow,
    arrow_down: ArrowDown,
    arrow_left: ArrowLeft,
    arrow_right: ArrowRight,
    arrow_up: ArrowUp,
    arrow_up_down: ArrowUpDown,
    arrow_up_to_line: ArrowUpToLine,
    arrows_in: Minimize2,
    arrows_out: Maximize2,
    arrows_repeat: Repeat2,
    bold: Bold,
    bolt: Bolt,
    calendar_blank: Calendar,
    calendar_days: CalendarDays,
    calendar_pen: CalendarClock,
    calendar_star: CalendarCheck,
    caret_down_solid: ChevronDown,
    archive: Archive,
    archiveRestore: ArchiveRestore,
    caret_down: ChevronDown,
    caret_left: ChevronLeft,
    caret_right: ChevronRight,
    caret_up: ChevronUp,
    chartLineUp: TrendingUp,
    check_circle_wavy: BadgeCheck,
    check: Check,
    checkbox_checked_solid: SquareCheck,
    checkbox_checked: SquareCheck,
    checkbox_unchecked: Square,
    checkCircleSolid: CheckCircle,
    clock: Timer,
    clone: Copy,
    code_block: SquareCode,
    code: Code,
    comment: MessageSquare,
    copy: Copy,
    domino: GripVertical,
    dot: Circle,
    emptySet: Ban,
    ellipsisVertical: EllipsisVertical,
    exclamationTriangleSolid: TriangleAlert,
    external_link: ExternalLink,
    eye: Eye,
    eye_slash: EyeOff,
    filter: ListFilter,
    fire: Flame,
    flask: FlaskConical,
    folder: Folder,
    gcal: logos.gcal,
    gear: Settings,
    globe: Globe,
    hamburger: Menu,
    headphones: Headphones,
    houseDay: House,
    inbox: Inbox,
    infinity: Infinity,
    infoCircleSolid: Info,
    italic: Italic,
    label: Tag,
    link: Link,
    link_slashed: Link2Off,
    list_ol: ListOrdered,
    list_ul: List,
    list: List,
    magnifying_glass: Search,
    megaphone: Megaphone,
    note: StickyNote,
    pause: Pause,
    penToSquare: SquarePen,
    pencil: Pencil,
    play: Play,
    plus: Plus,
    priority_high: CircleChevronUp,
    priority_low: CircleChevronDown,
    priority_medium: CircleDot,
    priority_none: Minus,
    priority_urgent: CircleArrowUp,
    priority: CircleArrowUp,
    quote_right: Quote,
    rankingStar: Star,
    repository: Boxes,
    save: Save,
    share: Share,
    sidebar: PanelLeft,
    sidebarFlipped: PanelRight,
    sort: ListFilter,
    sortArrows: ArrowUpDown,
    spinner: RefreshCw,
    strikethrough: Strikethrough,
    square: FilledSquare,
    squarePlus: SquarePlus,
    squareMinus: SquareMinus,
    subtask: ListTree,
    timer: Timer,
    trash: Trash,
    underline: Underline,
    user: User,
    users: Users,
    video: Video,
    warning: CircleAlert,
    warningTriangle: TriangleAlert,
    x: X,
})

export const buttons: { [key: string]: string } = {
    google_sign_in: '/images/google_sign_in.png', //missing svg
}

export type TLogoImage = keyof typeof logos
export type TIconImage = keyof typeof icons
